/*
 * File: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice\src\Content\Table\Table.tsx
 * Project: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice
 * Created Date: Thursday June 8th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday, 26th September 2023 02:06:53
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import PaginationCustom from "Content/PaginationCustom/PaginationCustom";
import { useEffect, useState } from "react";
import { TableType } from "Type/tableType";
import { GetCurrentCarPage, GetCurrentNbPage } from "Utils/UrlParams";
import { TableBody, TableContainer, TableHead, TableRow, Table as TableMui } from "@mui/material";

function Table(props: TableType) {
    const [page, setPage] = useState(GetCurrentCarPage);
    const [rowsPerPage, setRowsPerPage] = useState(GetCurrentNbPage(props.rowPerPageOptions));
    const pagination = props.pagination || props.pagination === undefined ? true : false;
    const pointer = props.cursor || props.cursor === undefined ? true : false;
    const [rows, setRows] = useState(props.rows);

    useEffect(() => {
        setRows(props.rows);
    },[props.rows]);

    return(
        <TableContainer className={`overflow-auto mb-5`}>
            <TableMui stickyHeader aria-label="custom pagination table"
                className={`table ${props.unStriped ? "": "table-striped"} ${props.unHover ? "": "table-hover"} ${pointer ? "cursor-pointer": ""} ${props.className ?? ""}`}>
                <TableHead>
                    <TableRow>
                        {
                            pagination ? <PaginationCustom rowPerPageOptions={props.rowPerPageOptions} nbItem={props.nbTotalElement} page={page} rowsPerPage={rowsPerPage} changeRowPerPage={setRowsPerPage} changePage={setPage} /> : null
                        }
                    </TableRow>
                    <TableRow>
                        {props.header}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows ?? props.children}
                </TableBody>
                <tfoot>
                    <TableRow>
                        {
                            pagination && props.botPagination ? <PaginationCustom nbItem={props.nbTotalElement} page={page} rowsPerPage={rowsPerPage} changeRowPerPage={setRowsPerPage} changePage={setPage} /> : null
                        }
                    </TableRow>
                </tfoot>
            </TableMui>
        </TableContainer>
    );
};

export default Table;
